module.exports = __webpack_public_path__ + "static/blue-front-a4f23d6007d4157584ac17c58428a94c.png";